import React, { useState } from 'react';

import { Flex } from 'antd-v5';
import cn from 'classnames';
import { MdNewReleases, MdSearch } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';

import { Input, S } from '@modules/shared/components';

import { CategoryPanels } from '../constants';
import PermissionsCollabsable from './components/PermissionsCollabsable';
import { PermsPanelFilterCard } from './components/PermsPanelFilter';
import styles from './permissionsTab.less';

export const PermissionsTab: React.FC = () => {
  const [searchGlobalTxt, setSearchGlobalTxt] = useState<string>('');
  const [globalPositionsFilter, setGlobalPositionsFilter] =
    useState<string[]>();

  const handleGlobalPositionFilterChange = (filterValue: string[]) =>
    setGlobalPositionsFilter(filterValue);

  return (
    <div className={styles.tabContainer}>
      <div className={styles.legendContainer}>
        <div className={styles.instructionContainer}>
          <div className={styles.fakeChkbx}></div>
          <S size="3" bold>
            <FormattedMessage id="permissionManager.permissionTab.roleRequired" />
          </S>
        </div>
        <div className={styles.instructionContainer}>
          <MdNewReleases className={styles.istructionIcon} />
          <S size="3" bold>
            <FormattedMessage id="permissionManager.permissionTab.recommendedPosition" />
          </S>
        </div>
      </div>
      <Flex align="center" gap={8} wrap={'wrap'}>
        <Input
          size="large"
          rounded
          addonAfter={<MdSearch />}
          className={cn(styles.searchInput, styles.globalSearchInput)}
          placeholder="Search all by Name"
          value={searchGlobalTxt}
          onChange={e => setSearchGlobalTxt(e.target.value)}
        />
        <PermsPanelFilterCard
          className={cn(styles.positionSelect, styles.globalPositionSelect)}
          onPositionFilterChange={handleGlobalPositionFilterChange}
        />
      </Flex>
      <div className={styles.youthsInfo}>
        <Text color="color-primary" font="body-caption">
          <FormattedMessage id="permissionManager.permissionTab.info.youths" />
        </Text>
      </div>
      {CategoryPanels.map(panelType => (
        <PermissionsCollabsable
          key={panelType}
          panelType={panelType}
          searchGlobalTxt={searchGlobalTxt}
          globalPositionsFilter={globalPositionsFilter}
        />
      ))}
    </div>
  );
};
